<template>
    <div>
        <span class="btn-group btn-group-sm">
            <a class="btn" :class="hideTrashedClassName" :href="hideTrashedURL">
                <DataLabel
                    :item="$t('common.toggles.trashed.off')"
                    :hide-icon="isShowingTrashed"
                    icon-class="fa fa-fw fa-check" />
            </a>

            <a class="btn" :class="showTrashedClassName" :href="showTrashedURL">
                <DataLabel
                    :item="$t('common.toggles.trashed.on')"
                    :hide-icon="!isShowingTrashed"
                    icon-class="fa fa-fw fa-check" />
            </a>
        </span>
    </div>
</template>

<script>
import URI from 'urijs';

import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'ToggleTrashed',

    components: {DataLabel},

    computed: {
        isShowingTrashed() {
            return this.uri.hasQuery('show_all', 1);
        },

        hideTrashedClassName() {
            return !this.isShowingTrashed ? ['btn-info', 'active'] : 'btn-light';
        },

        hideTrashedURL() {
            return this.uri.removeQuery(['show_all', 'page'])
                .addQuery({'page': 1})
                .toString();
        },

        showTrashedClassName() {
            return this.isShowingTrashed ? ['btn-info', 'active'] : 'btn-light';
        },

        showTrashedURL() {
            return this.uri.removeQuery(['show_all', 'page'])
                .addQuery({'show_all': 1, 'page': 1})
                .toString();
        },
    },

    created() {
        this.uri = URI(window.location.href);
    },
};
</script>
